// TODO: a similar interface `BlockReason` used in shared, check... They actually should be different
export var PickingBlockReason;
(function (PickingBlockReason) {
    PickingBlockReason[PickingBlockReason["Defect"] = 1] = "Defect";
    PickingBlockReason[PickingBlockReason["Counterfeit"] = 2] = "Counterfeit";
    PickingBlockReason[PickingBlockReason["Undersupply"] = 3] = "Undersupply";
    PickingBlockReason[PickingBlockReason["Loss"] = 4] = "Loss";
    PickingBlockReason[PickingBlockReason["Refusal"] = 5] = "Refusal";
    PickingBlockReason[PickingBlockReason["Refund"] = 6] = "Refund";
})(PickingBlockReason || (PickingBlockReason = {}));
